<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer003">
<p class="structure-next" id="calibre_pb_4"><span class="character-bold2"> </span></p>
<p class="centered"><span class="character-bold3">A Mother’s Courage to Awaken</span></p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"><span class="charoverride3">Hope and Inspiration from My Daughter’s Journey in the Afterlife</span></p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"><span class="character-bold4">Paula Petry, PhD</span></p>
<p class="centered"> </p>
<p class="centered"><img alt="" class="_idgenobjectattribute" src="OEBPS/image/Mango_Publishing_Group.png"/></p>
<p class="centered">Coral Gables</p>
<div class="calibre2" id="calibre_pb_5"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_002.vue?48cebf51